import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { ScrollPane } from "@common/scrollPane";
import { Loader } from "@common/loader";
import { PlusIcon } from "@common/assets/plusIcon";
import { TrashIcon } from "@common/trashIcon";
import { CogWheelIcon } from "@common/cogWheelIcon";
import { ContextualMenu } from "@common/contextualMenu";
import assistantIcon from "@scenes/assistantShortcut/icon.png";
import { HistoryIcon } from "./historyIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function ConversationSidebar({
  conversations,
  selectedConversationId,
  isPending,
  select,
  createNew,
  remove,
  resetMemory,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.conversationSidebar}>
      <div className={styles.logoBox}>
        <img src={assistantIcon} className={styles.logo} alt="" />
      </div>
      <div className={styles.header}>
        <div className={styles.title}>
          <HistoryIcon className={styles.historyIcon} />
          <h3>{t("chatbot.sidebar.title")}</h3>
        </div>
        <div
          className={styles.newButton}
          title={t("chatbot.sidebar.newConversation")}
          onClick={createNew}
        >
          <PlusIcon className={styles.icon} />
        </div>
      </div>
      <ScrollPane style={styles.scrollPane}>
        <div className={styles.list}>
          {isPending && <Loader />}
          {!isPending && conversations.length === 0 && (
            <p className={styles.placeholder}>{t("chatbot.sidebar.empty")}</p>
          )}
          {!isPending &&
            [...conversations]
              .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
              .map((conversation) => (
                <div
                  key={conversation.uuid}
                  className={classNames(styles.conversation, {
                    [styles.selected]:
                      conversation.uuid === selectedConversationId,
                  })}
                  onClick={() => select(conversation.uuid)}
                >
                  <p className={styles.conversationTitle}>
                    {conversation.title || t("chatbot.sidebar.untitled")}
                  </p>
                  <div
                    className={styles.contextualMenu}
                    onClick={(event) => event.stopPropagation()}
                  >
                    <ContextualMenu
                      items={[
                        {
                          name: t("chatbot.sidebar.resetMemory"),
                          renderIcon: (className) => (
                            <CogWheelIcon className={className} />
                          ),
                          act: () => resetMemory(conversation),
                        },
                        {
                          name: t("chatbot.sidebar.delete"),
                          color: "#db5f63",
                          renderIcon: (className) => (
                            <TrashIcon className={className} />
                          ),
                          act: () => remove(conversation),
                        },
                      ]}
                    />
                  </div>
                </div>
              ))}
        </div>
      </ScrollPane>
    </div>
  );
}

export { ConversationSidebar };
